import React from 'react';
import { HStack, Box, Text } from '@chakra-ui/react';
import { UserStatus } from 'src/api/users';

type UserStatusBadgeProps = {
  status: UserStatus;
};

const statusConfig: Record<UserStatus, { label: string; color: string }> = {
  active: { label: 'Active', color: 'green.500' },
  pending: { label: 'Pending', color: 'orange.400' },
  inactive: { label: 'Inactive', color: 'gray.400' },
};

export const UserStatusBadge: React.FC<UserStatusBadgeProps> = ({ status }) => {
  const config = statusConfig[status];

  return (
    <HStack spacing={2}>
      <Box w={2} h={2} borderRadius="full" bg={config.color} />
      <Text fontSize="sm" color={config.color}>
        {config.label}
      </Text>
    </HStack>
  );
};
